export const VIDEO_TITLE_MAX_LENGTH = 32;
